export default __webpack_public_path__ + "static/media/004-B-solidaire.4f253daf.svg";